import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Cell from "../components/Cell.jsx";
import PublicContext from "../contexts/PublicContext.jsx";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import classNames from "classnames";

function DisplayHtmlAndSwiperPage({ getAll, getSelected, path, title = "" }) {
	const { id } = useParams();
	const navigate = useNavigate();
	const [items, setItems] = useState([]);
	const [selected, setSelected] = useState(null);
	const [loadingItems, setLoadingItems] = useState(true);
	const [loadingSelected, setLoadingSelected] = useState(true);
	const [loadingImages, setLoadingImages] = useState({});

	// Recupera tutte le opzioni
	useEffect(() => {
		if (getAll === undefined) return;
		getAll()
			.then((res) => setItems(res.data.data))
			.finally(() => setLoadingItems(false));
	}, [getAll]);

	// Recupera i dettagli della voce selezionata
	useEffect(() => {
		if (getSelected === undefined) return;
		if (id) {
			setLoadingSelected(true);
			getSelected(id)
				.then((res) => setSelected(res.data.data))
				.finally(() => setLoadingSelected(false));
		}
	}, [id, getSelected]);

	// Gestore per cambiare la voce selezionata
	const handleMenuClick = (selectedId) => {
		navigate(`${path}/${selectedId}`);
	};

	const handleImageLoad = (index) => {
		setLoadingImages((prev) => ({ ...prev, [index]: true }));
	};

	return (
		<PublicContext>
			<div className="flex flex-col h-full">
				{/* Menu con Swiper */}
				<div className="bg-gray-100 p-4 shadow-md">
					{loadingItems ? (
						<div className="flex justify-center gap-4">
							<Skeleton height={150} width={250} />
							<Skeleton height={150} width={250} />
							<Skeleton height={150} width={250} />
							<Skeleton height={150} width={250} />
							<Skeleton height={150} width={250} />
						</div>
					) : (
						<Swiper
							modules={[Navigation, Pagination, Autoplay]}
							spaceBetween={1}
							slidesPerView={2}
							navigation
							pagination={{ clickable: true }}
							loop={true}
							autoplay={{
								delay: 3000,
								disableOnInteraction: false,
							}}
							breakpoints={{
								640: { slidesPerView: 3 },
								1024: { slidesPerView: 6 },
								1280: { slidesPerView: 7 },
							}}
							className="w-full"
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{items.map((item, index) => (
								<SwiperSlide key={index}>
									<div
										key={item.id}
										onClick={() => handleMenuClick(item.id)}
										className={`flex flex-col items-center p-4 text-center hover:bg-gray-200 rounded-lg cursor-pointer ${
											Number(id) === item.id ? "bg-gray-300" : ""
										}`}
									>
										{!loadingImages[index] && (
											<Skeleton circle={true} height={64} width={64} />
										)}
										<img
											src={item.src}
											alt={item.label}
											className="w-16 h-16"
											onLoad={() => handleImageLoad(index)}
											style={{
												display: loadingImages[index] ? "block" : "none",
											}}
										/>
										<span className="text-sm mt-2">{item.label}</span>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					)}
				</div>

				{/* Corpo principale */}
				<div className="container mx-auto flex-1 p-2 md:p-4">
					{loadingSelected ? (
						<Cell rows={1} className=" items-center w-full">
							<Skeleton height={50} className="mx-auto" />
							<Skeleton height={100} />
							<Skeleton height={50} count={3} />
							<Skeleton height={100} />
							<Skeleton height={50} count={3} />
						</Cell>
					) : (
						selected && (
							<Cell rows={1}>
								<h1
									className={classNames(
										"text-3xl lg:text-4xl xl:text-5xl font-bold text-center mb-4",
										selected.color ? `text-${selected.color}` : "text-blue-500"
									)}
								>
									{title} {selected.label}
								</h1>
								<div
									className="prose mx-auto p-2 md:p-5 lg:p-7"
									dangerouslySetInnerHTML={{ __html: selected.html }}
								></div>
							</Cell>
						)
					)}
				</div>
			</div>
		</PublicContext>
	);
}

export default DisplayHtmlAndSwiperPage;
